import type { SentryLike } from "./sentry-like.types";

export type { SentryLike } from "./sentry-like.types";

export const sentryModuleState: { module: SentryLike | null } = { module: null };
